import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { OrganisationDocument } from "@ServerTypes/organisations/organisations.schema";

const initialState: OrganisationDocument = {};

const organisationDetailsSlice = createSlice({
  name: "organisationDetails",
  initialState,
  reducers: {
    setOrganisationDetails: (_state: OrganisationDocument, action: PayloadAction<OrganisationDocument>) =>
      action.payload,
  },
});

export const { setOrganisationDetails } = organisationDetailsSlice.actions;

export const organisationDetails = organisationDetailsSlice.reducer;

export default organisationDetailsSlice.reducer;
